// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popupComponent-module_popupBoxContentWrapper__i6M7V {
    background: var(--white);
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    & .popupComponent-module_fixedHeight__y4evY {
        height: calc(100vh - 48px);
        max-height: calc(100vh - 48px);
    }
}

.popupComponent-module_popupBoxContent__ADGxa {
    max-height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    flex: 1;
}

.popupComponent-module_popupBoxHeader__SXIVE {
    padding: 32px 24px 48px;
    text-align: var(--textAlign);

    @media screen and (min-width: 708px) {
        padding: 48px 32px 64px;
    }

    & p {
        margin-top: 0;
        margin-bottom: 16px;

        &:last-child {
            margin-bottom: 0;
        }
    }
}

.popupComponent-module_popupInternalContent__oibgV {
    padding: 0 0 24px 0;
    display: flex;
    flex-direction: column;
    flex: 1;

    @media screen and (min-width: 708px) {
        padding: 0 0 32px 0;
    }
}

.popupComponent-module_withSeparator__FmsmK {
    padding: 24px 0;
    border-top: 1px solid var(--grey_16_lc);

    @media screen and (min-width: 708px) {
        padding: 32px 0;
    }
}

.popupComponent-module_popupExternalContent__qzyfW {
    background: var(--white);
    border-radius: 12px;
    padding: 14px 0;
    margin-top: 8px;

    @media screen and (min-width: 708px) {
        border-radius: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/UI/Popup/popupComponent.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;;IAEtB;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;;IAE5B;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,mBAAmB;;QAEnB;YACI,gBAAgB;QACpB;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,OAAO;;IAEP;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,uCAAuC;;IAEvC;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;IACf,eAAe;;IAEf;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".popupBoxContentWrapper {\n    background: var(--white);\n    border-radius: 12px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n\n    & .fixedHeight {\n        height: calc(100vh - 48px);\n        max-height: calc(100vh - 48px);\n    }\n}\n\n.popupBoxContent {\n    max-height: 100%;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.popupBoxHeader {\n    padding: 32px 24px 48px;\n    text-align: var(--textAlign);\n\n    @media screen and (min-width: 708px) {\n        padding: 48px 32px 64px;\n    }\n\n    & p {\n        margin-top: 0;\n        margin-bottom: 16px;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n}\n\n.popupInternalContent {\n    padding: 0 0 24px 0;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n\n    @media screen and (min-width: 708px) {\n        padding: 0 0 32px 0;\n    }\n}\n\n.withSeparator {\n    padding: 24px 0;\n    border-top: 1px solid var(--grey_16_lc);\n\n    @media screen and (min-width: 708px) {\n        padding: 32px 0;\n    }\n}\n\n.popupExternalContent {\n    background: var(--white);\n    border-radius: 12px;\n    padding: 14px 0;\n    margin-top: 8px;\n\n    @media screen and (min-width: 708px) {\n        border-radius: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popupBoxContentWrapper": `popupComponent-module_popupBoxContentWrapper__i6M7V`,
	"fixedHeight": `popupComponent-module_fixedHeight__y4evY`,
	"popupBoxContent": `popupComponent-module_popupBoxContent__ADGxa`,
	"popupBoxHeader": `popupComponent-module_popupBoxHeader__SXIVE`,
	"popupInternalContent": `popupComponent-module_popupInternalContent__oibgV`,
	"withSeparator": `popupComponent-module_withSeparator__FmsmK`,
	"popupExternalContent": `popupComponent-module_popupExternalContent__qzyfW`
};
export default ___CSS_LOADER_EXPORT___;
